import React, { useEffect, useRef, useState } from 'react';

const Home = () => {
  const audioRef = useRef(null);
  const [isAudioOn, setIsAudioOn] = useState(false);

  useEffect(() => {
    const audio = new Audio('/background-music.mp3');
    audio.loop = true;
    audio.volume = 0.45;
    audioRef.current = audio;

    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    const audio = audioRef.current;

    if (!audio) {
      return;
    }

    if (isAudioOn) {
      const playPromise = audio.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          setIsAudioOn(false);
        });
      }
      return;
    }

    audio.pause();
  }, [isAudioOn]);

  const toggleAudio = () => {
    setIsAudioOn((prev) => !prev);
  };

  return (
    <div className="App">
      <div className="video-background">
        <video autoPlay loop muted playsInline>
          <source src="/background.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="App-content">
        <header className="App-header">
          <div className="fantasy-scroll">
            <h1>Elsareth</h1>
            <p className="tagline">A fantasy world shaped through collaboration.</p>
          </div>
        </header>
        <main className="App-body">

        </main>
        <footer className="App-footer">
        </footer>
        <div className="fantasy-scroll bottom-scroll" aria-label="Elsareth social links">
          <div className="social-links">
            <button
              type="button"
              className={`audio-toggle ${isAudioOn ? 'is-playing' : ''}`}
              onClick={toggleAudio}
              aria-label={isAudioOn ? 'Turn background music off' : 'Turn background music on'}
              aria-pressed={isAudioOn}
            >
              <span className="sr-only">Toggle background music</span>
              <i className={`fa-solid ${isAudioOn ? 'fa-volume-high' : 'fa-volume-xmark'}`} aria-hidden="true"></i>
            </button>
            <a
              href="https://discord.gg/MeNKJjMHqr"
              className="icon-link"
              aria-label="Discord"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-discord" aria-hidden="true"></i>
            </a>
            <a
              href="https://x.com/elsareth"
              className="icon-link"
              aria-label="X"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
